// Core
import { useState, useEffect, useRef } from 'react';
import { MdInfoOutline } from "react-icons/md";
import { FaOilCan } from "react-icons/fa";
import { FaSitemap } from "react-icons/fa";
import { MdDoubleArrow } from 'react-icons/md';
import { FaHandshake } from "react-icons/fa6";
import { HiEmojiHappy } from "react-icons/hi";
import { MdToken } from 'react-icons/md';
import { FaWifi } from "react-icons/fa";

// Chakra 
import { 
  Box,
  Button,
  Divider,
  Image,
  Flex, 
  Grid,
  FormControl,
  FormLabel,
  FormHelperText,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Spinner,
  Text, 
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';

import infoImage from '../../../assets/info.png';
import roadSh from '../../../assets/road-sh.png';

const InfoModal = ({ 
  isOpen, onOpen, onClose
}) => {

  const onCloseHandle = () => {
    localStorage.setItem('newUser', true); 
    onClose()
  };

  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  }, [isOpen]);

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}>
      <ModalOverlay />
      <ModalContent ref={modalRef} className="modal__simple modal__info" maxW={{ sm: '100%', zIndex: '99999' }}>
        <ModalBody>
          <Box position="relative">
            <Text variant="title-lg" fontWeight="900" fontSize="33px" lineHeight="normal">
              <span style={{ color: 'rgba(255, 187, 24, 1)'}}>SPACE</span>CRAFT! <br />
              <Text as="span" variant="title-lg" fontWeight="900" fontSize="26px">Conquer the Cosmos!</Text>
            </Text>
            
            <Text p="0 20px" mt="24px" color="#dadada !important" variant="title-lg" fontSize="21px !important" lineHeight="normal">
              Embark on an <span style={{ color: 'rgba(255, 187, 24, 1)'}}>interstellar</span>
              adventure in Spacecraft, where you pilot powerful spaceships, 
              <span style={{ color: 'rgba(255, 187, 24, 1)'}}>collect valuable tokens</span>, and explore the vastness of space! 🚀✨
            </Text>

            <Text p="0 30px" mt="24px" color="white" variant="text" fontSize="14px !important" fontStyle="italic" lineHeight="normal">
              <span style={{ color: 'rgba(255, 187, 24, 1)'}}>No rush, no stress</span> — just pure chill vibes on the sky. 🌟 
              Start today!
            </Text>

            <Flex
              onClick={onCloseHandle} 
              mt="12px" 
              gap="0px"
              alignItems="center"
              padding="20px 20px 0px 30px"
              borderRadius="20px"
              display="inline-flex">
              <Text 
                color="rgba(255, 187, 24, 1)"
                variant="title-lg" 
                textTransform="uppercase"
                fontWeight="1000"
                fontSize="40px">Start</Text>
              <MdDoubleArrow fontSize="67px" color="rgba(255, 187, 24, 1)" />
            </Flex>
          </Box>          
        </ModalBody>
      </ModalContent>
    </Modal> 
  );
};

export default InfoModal;